import Vue from 'vue';
import VueMeta from 'vue-meta';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import store from './store';
import '@mdi/font/css/materialdesignicons.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@/styles/vuetifyReset.scss';
import '@/styles/common.scss';

// Configure Vue
Vue.config.productionTip = true;
Vue.use(VueMeta);

// Global event bus for component communication
Vue.prototype.$eventBus = new Vue();

// Navigation helper
Vue.prototype.$moveBack = function () {
  if (this.$router) {
    this.$router.go(-1);
  } else {
    console.warn('Router not available');
  }
};

// Number formatting helper
Vue.prototype.$formatNumber = function (number, options = {}) {
  const defaults = {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    currency: 'USD',
    notation: 'standard'
  };

  const config = { ...defaults, ...options };

  return new Intl.NumberFormat("en-US", config).format(number);
};

// Date formatting helper
Vue.prototype.$formatDate = function (date, options = {}) {
  if (!date) return '';

  const defaults = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: undefined,
    minute: undefined,
    second: undefined,
    hour12: false
  };

  const config = { ...defaults, ...options };

  return new Intl.DateTimeFormat("en-US", config).format(new Date(date));
};

// Relative time formatter
Vue.prototype.$timeAgo = function (date) {
  if (!date) return '';

  const now = new Date();
  const past = new Date(date);
  const diffMs = now - past;
  const diffSec = Math.round(diffMs / 1000);
  const diffMin = Math.round(diffSec / 60);
  const diffHour = Math.round(diffMin / 60);
  const diffDay = Math.round(diffHour / 24);

  if (diffSec < 60) return 'just now';
  if (diffMin < 60) return `${diffMin} minute${diffMin > 1 ? 's' : ''} ago`;
  if (diffHour < 24) return `${diffHour} hour${diffHour > 1 ? 's' : ''} ago`;
  if (diffDay < 30) return `${diffDay} day${diffDay > 1 ? 's' : ''} ago`;

  return this.$formatDate(date, { year: 'numeric', month: 'short', day: 'numeric' });
};



// Create and mount Vue instance
new Vue({
  store,
  router,
  vuetify,
  render: h => h(App),
  mounted() {
    // Listen for global events
    this.$root.$on('show-contact', () => {
      // Find any component that has a showContact method and call it
      const homeView = this.$children[0].$children.find(c => c.$options.name === 'HomeView');
      if (homeView && typeof homeView.showContact === 'function') {
        homeView.showContact();
      }
    });


  }
}).$mount('#app');

